"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorsDesc = void 0;
var errorsDesc = {
  INTERNAL_SERVER_ERROR: 'Internal server error',
  SOMETHING_WRONG: 'Sorry! Something went wrong. Please try again.'
};
exports.errorsDesc = errorsDesc;